import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import { styled } from "@mui/material";
import dashboardIn from "../../assets/dashboard/dashboard.svg";
import dashboardAc from "../../assets/dashboard/dashboardAc.svg";

import consumptionAc from "../../assets/dashboard/consumption.svg";
import energyIn from "../../assets/dashboard/energy.svg";
import energyAc from "../../assets/dashboard/energyAc.svg";
import consumptionIn from "../../assets/dashboard/consumptionIn.svg";



const drawerWidth = 280;

export const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

export const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  background: "white",
  boxShadow: `rgba(0, 0, 0, 0.16) 0px 1px 4px`,
  ...(open
    ? {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }
    : {
      marginLeft: drawerWidth,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export const drawerList = [
  {
    title: "Dashboard",
    id: 1,
    active_icon: dashboardAc,
    inactive_icon: dashboardIn,
    path: "dashboard",
  },
  {
    title: "Consumption Certificate",
    id: 2,
    active_icon: consumptionAc,
    inactive_icon: consumptionIn,
    path: "consumption-certificate",
  },

  {
    title: "Need Certificate",
    id: 3,
    active_icon: energyAc,
    inactive_icon: energyIn,
    path: "energy-certificate",
  },
];
export const drawerListGerm = [
  {
    title: "Dashboard",
    id: 1,
    active_icon: dashboardAc,
    inactive_icon: dashboardIn,
    path: "dashboard",
  },
  {
    title: "Verbrauchsausweis",
    id: 2,
    active_icon: consumptionAc,
    inactive_icon: consumptionIn,
    path: "consumption-certificate",
  },

  {
    title: "Bedarfsausweis",
    id: 3,
    active_icon: energyAc,
    inactive_icon: energyIn,
    path: "energy-certificate",
  },
];